import { gql } from '@apollo/client';

export const QUERY_NOTIFICATIONS = gql`
  query QueryNotifications {
    notifications(sort: "createdAt:desc") {
      data {
        id
        attributes {
          title
          description
          hidden
          link {
            name
            url
            button
          }
        }
      }
    }
  }
`;
